import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserDetailsService } from 'src/app/Shared/UserDetails/user-details.service';
import { RestoredataVM } from 'src/app/ViewModels/RestoredataVM';

@Component({
  selector: 'app-deletedfiles',
  templateUrl: './deletedfiles.component.html',
  styleUrls: ['./deletedfiles.component.scss']
})
export class 
DeletedfilesComponent implements OnInit {
  accid: string;
  name: string;
  deletedlist: any;
  uid: string;
  GUID: string;

  constructor(private userservice: UserDetailsService, private router: Router,private spinner:NgxSpinnerService) {
    this.spinner.show();
    window.scrollTo(0,0);
    
    if (localStorage.getItem("IsLoggedIn") == "true") {

      this.uid = localStorage.getItem("userId");
      this.accid = localStorage.getItem("uid");
      this.name = localStorage.getItem("UserName");
      this.GUID=localStorage.getItem("GUID");

    }
  }

  ngOnInit() {
  this.GetAllDeletedFiles();
  setTimeout(() => {
    var footer = document.getElementById("footer");
    if(footer.style.display=="none"){
      footer.style.display = "block";
    }
  }, 1000);
  }
  GetAllDeletedFiles(){
    this.userservice.Getalldeletetrns(this.GUID).subscribe((respose: any) => {
      this.deletedlist = respose;
      this.spinner.hide();
    });
  }
  Restorefile(data){
    
      const inputRequest: RestoredataVM = {
        BlockId : data.blockId,
        FolderId: data.folderID,
        UID: this.uid,
        GUID: this.GUID
      }
      this.userservice.PostRestoredata(inputRequest).subscribe(
        (data: any) => {
          if (data == "1") {
            alert("Restored succesfully");
            this.GetAllDeletedFiles()
            //this.router.navigate(['/allfolders']);
          }          
          else {
            alert("Something went wrong. Try again.!!");
          }
        });
    }
  
}
